import type { PerioToothData } from '@/modules/insuranceExport/types';

export function formatState(
  state: PerioToothData['plaque'] | PerioToothData['boneLoss'],
) {
  if (!state) return '---';
  if (state === 'none') return '---';
  if (state === 'light') return 'L';
  if (state === 'moderate') return 'MO';
  if (state === 'heavy') return 'H';
  if (state === 'normal') return 'N';
  if (state === 'mild') return 'MI';
  if (state === 'severe') return 'S';
}

export function getToothStatusAbbreviation(
  status: PerioToothData['toothState'],
): string {
  switch (status) {
    case 'present':
      return ''; // No mark needed
    case 'missing':
      return 'X'; // Strike-through or X
    case 'unerupted':
      return 'UE';
    case 'pontic':
      return 'P';
    case 'implant':
      return 'I';
    case 'crown':
      return 'C';
    case 'implant_crown':
      return 'IC';
    case 'impacted_mesial':
      return 'IM';
    case 'impacted_distal':
      return 'ID';
    default:
      return ''; // fallback for unknown status
  }
}
